const setNotifications = (state = false, action) => {
  switch (action.type) {
    case "SETNOTIFICATION":
      return action.payload;
    default:
      return state;
  }
};

export default setNotifications;
